import { render, staticRenderFns } from "./arabicIcon.vue?vue&type=template&id=12aa80d3"
import script from "./arabicIcon.vue?vue&type=script&lang=js"
export * from "./arabicIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports